import { authenticatedAxios } from "../utils/apiService";
import { storeDataInLocalStorage } from "../utils/localStorage";

export const getClinicDetails = async (showAlert) => {
  try {
    const response = await authenticatedAxios.get("/v1/clinic/profile/details");
    storeDataInLocalStorage("clinicData", response.data.data);
  } catch (error) {
    showAlert(error?.response?.data?.message || "Something went wrong.", "error");
  }
};

export const updateClinicDetails = async (data, showAlert, refreshData, startLoading, stopLoading) => {
  try {
    startLoading();

    await authenticatedAxios.put(`/v1/clinic/profile/update`, data);

    refreshData();
    showAlert("This clinic data has been updated.", "success");
  } catch (error) {
    showAlert(error?.response?.data?.message || "Something went wrong.", "error");
  } finally {
    stopLoading();
  }
};

export const addEmbroysRating = async (payload, showAlert, goBack, url) => {
  try {
    let res = {};
    if (url.includes("create")) res = await authenticatedAxios.post(url, payload);
    else res = await authenticatedAxios.put(url, payload);
    const { message } = res.data;
    goBack();
    showAlert(message, "success");
  } catch (error) {
    showAlert(error?.response?.data?.message || "Something went wrong.", "error");
  }
};

export const addOocyteRating = async (payload, showAlert, goBack, url) => {
  try {
    let res = {};
    if (url.includes("create")) res = await authenticatedAxios.post(url, payload);
    else res = await authenticatedAxios.put(url, payload);
    const { message } = res.data;
    goBack();
    showAlert(message, "success");
  } catch (error) {
    showAlert(error?.response?.data?.message || "Something went wrong.", "error");
  }
};

export const addClinicUrls = async (payload, startLoading, stopLoading, showAlert) => {
  try {
    startLoading();
    await authenticatedAxios.put("/v1/clinic/grading/update/url", payload);
    showAlert("Successfully updated.", "success");
  } catch (error) {
    showAlert(error?.response?.data?.message || "Something went wrong.", "error");
  } finally {
    stopLoading();
  }
};

export const deleteOneGrade = async (url, goBack, showAlert) => {
  try {
    await authenticatedAxios.delete(url);
    goBack();
    showAlert("Successfully deleted.", "success");
  } catch (error) {
    showAlert(error?.response?.data?.message || "Something went wrong.", "error");
  }
};

export const deleteProfile = async (showAlert) => {
  try {
    await authenticatedAxios.delete("/v1/clinic/profile/image");
  } catch (error) {
    showAlert(error?.response?.data?.message || "Something went wrong.", "error");
  }
};
